import { PageRequest } from "@shared/zod/schemas/requests/page"
import { AdminPatientAccountsPageResponse } from "@shared/zod/schemas/responses/patientAccount"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const findAll = async (query?: PageRequest): Promise<AdminPatientAccountsPageResponse> => {
  const resp = await axiosAuth({
    url: "/admin/patient-accounts",
    method: "get",
    params: query,
  })
  return resp.data
}
